const SW_RESET_VERSION = "sw-reset-2026-02-20-isolation-fix";
const SW_RESET_STORAGE_KEY = "vintmap_sw_reset_version";

/**
 * One-time emergency cleanup for broken/stale service workers and caches.
 * Runs once per browser for SW_RESET_VERSION, then no-ops.
 */
export async function runServiceWorkerReset(): Promise<void> {
  if (typeof window === "undefined" || typeof navigator === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  try {
    const alreadyDone = window.localStorage.getItem(SW_RESET_STORAGE_KEY);
    if (alreadyDone === SW_RESET_VERSION) return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      try {
        await registration.unregister();
      } catch (error) {
        console.warn("[SW-RESET] Failed to unregister registration:", error);
      }
    }

    if ("caches" in window) {
      try {
        const cacheKeys = await caches.keys();
        await Promise.all(
          cacheKeys
            .filter((key) => key.startsWith("vintmap-") || key.includes("workbox"))
            .map((key) => caches.delete(key))
        );
      } catch (error) {
        console.warn("[SW-RESET] Failed to delete one or more caches:", error);
      }
    }

    window.localStorage.setItem(SW_RESET_STORAGE_KEY, SW_RESET_VERSION);
    console.log("[SW-RESET] Completed emergency service worker cleanup.");
  } catch (error) {
    console.warn("[SW-RESET] Cleanup failed:", error);
  }
}

